import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { useShowSaveToFolderModal } from '@/shared/features/quiz-folder';
import { useCTAHandlers } from '../hooks/useCTAHandlers';
import { type CTAScenario } from '../hooks/useCTAScenario';
import { MobileGuestCTAButtons } from './MobileGuestCTAButtons';
import { MobileOwnerCTAButtons } from './MobileOwnerCTAButtons';
import { MobileOwnerLockedCTAButtons } from './MobileOwnerLockedCTAButtons';
import { MobileViewerCTAButtons } from './MobileViewerCTAButtons';
import { MobileViewerLockedCTAButtons } from './MobileViewerLockedCTAButtons';
export interface MobileCTAButtonGroupProps {
  scenario: CTAScenario;
  quizId: string;
  quizData: QuizSetDetailsRes;
}
export const MobileCTAButtonGroup = ({
  scenario,
  quizId,
  quizData
}: MobileCTAButtonGroupProps) => {
  const showSaveToFolderModal = useShowSaveToFolderModal();
  const {
    handleEnter,
    handleShare,
    handleDuplicate,
    handleEdit,
    handleGoToLms,
    handleDuplicateLocked,
    handleUpgradePlan
  } = useCTAHandlers({
    quizId,
    quizData,
    scenario
  });
  switch (scenario) {
    case 'guest':
      return <MobileGuestCTAButtons onCopy={handleDuplicate} onEnter={handleEnter} />;
    case 'owner':
      return <MobileOwnerCTAButtons onEnter={handleEnter} onShare={handleShare} onDuplicate={handleDuplicate} onEdit={handleEdit}
      // 데스크톱(`DesktopCTAButtonGroup`)과 같은 인자로 연다 — 폭만 다르고 동작은 같다.
      onMoveToFolder={() => void showSaveToFolderModal({
        id: quizId,
        intent: 'move',
        currentFolderId: quizData.folderId
      })} />;
    case 'viewer':
      return <MobileViewerCTAButtons onDuplicate={handleDuplicate} onEnter={handleEnter} />;
    case 'owner-locked':
      return <MobileOwnerLockedCTAButtons onDuplicateLocked={handleDuplicateLocked} onUpgradePlan={handleUpgradePlan} onGoToLms={handleGoToLms} onEdit={handleEdit} />;
    case 'viewer-locked':
      return <MobileViewerLockedCTAButtons onCopy={handleDuplicate} />;
    default:
      // eslint-disable-next-line no-case-declarations
      const _exhaustiveCheck: never = scenario;
      return null;
  }
};